import{__require as r}from"./Result.mjs";var s,t;function e(){if(t)return s;t=1;const e=r();return s=class{constructor(r){this.results=[],r&&r.results.map((r=>{this.results.push(new e(r))}))}}}export{e as __require};
